import React from 'react';
import PropTypes from 'prop-types';
import { sendGaEvent } from '@hydra/utils/googleAnalytics';
import formatNumber from '@hydra/utils/formatNumber';

import { makeStyles } from '@material-ui/core/styles';
import { Chip, Tabs, Tab } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  chip: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
    fontWeight: theme.typography.fontWeightBold,
    fontSize: theme.typography.fontSizeTiny,
    marginLeft: theme.spacing(1)
  },
  tabs: {
    marginBottom: theme.spacing(4),
    borderBottom: `1px solid ${theme.palette.divider}`
  },
  tab: {
    padding: theme.spacing(2.5, 2.75),
    fontWeight: theme.typography.fontWeightSemibold,
    minWidth: 0
  },
  wrapper: { flexDirection: 'row' }
}));

const sendGa = name => sendGaEvent('tab', 'click', `crawler-section-tab-${name}`);

const IssueCounterRow = ({ counters }) => {
  const classes = useStyles();
  const counterActive = counters.find(({ active }) => active);

  const handleClick = ({ link, name }) => {
    sendGa(name);
    window.location.href = link;
  };

  return (
    <Tabs
      value={counterActive && counterActive.name}
      indicatorColor='primary'
      variant='scrollable'
      className={classes.tabs}
    >
      {counters.map(({ name, label, amount, link }) => (
        <Tab
          className={classes.tab}
          onClick={() => handleClick({ link, name })}
          disableRipple
          value={name}
          key={name}
          classes={{
            wrapper: classes.wrapper
          }}
          label={(
            <span data-elevio={name}>
              {label}
              <Chip
                size='small'
                classes={{ root: classes.chip }}
                label={formatNumber(amount)}
              />
            </span>
          )}
        />
      ))}
    </Tabs>
  );
};

IssueCounterRow.propTypes = {
  counters: PropTypes.arrayOf(
    PropTypes.shape({
      active: PropTypes.boolean,
      amount: PropTypes.number,
      label: PropTypes.element,
      link: PropTypes.string,
      name: PropTypes.string
    })
  ).isRequired
};

export default IssueCounterRow;
